"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.springCalculation = void 0;
function springCalculation(gYear, days) {
    var year = 0, month = 0, day = 0;
    var dayReduction = days - 79;
    // year calculation
    year = gYear - 621;
    // in summer and spring
    if (dayReduction <= 186) {
        var leftOver = (days - 79) % 31;
        if (leftOver === 0) {
            month = Math.floor((days - 79) / 31);
            day = 31;
        }
        else {
            month = Math.floor((days - 79) / 31) + 1;
            day = leftOver;
        }
    }
    // in fall
    else {
        var leftOver = (days - 79 - 186) % 30;
        if (leftOver === 0) {
            month = Math.floor((days - 79 - 186) / 30) + 6;
            day = 30;
        }
        else {
            month = Math.floor((days - 79 - 186) / 30) + 7;
            day = leftOver;
        }
    }
    return { year: year, month: month, day: day };
}
exports.springCalculation = springCalculation;
